export var BackupZeroEtlIcebergTransformType;
(function (BackupZeroEtlIcebergTransformType) {
    BackupZeroEtlIcebergTransformType["BACKUP_ZERO_ETL_ICEBERG_TRANSFORM_TYPE_IDENTITY"] = "IDENTITY";
    BackupZeroEtlIcebergTransformType["BACKUP_ZERO_ETL_ICEBERG_TRANSFORM_TYPE_YEAR"] = "YEAR";
    BackupZeroEtlIcebergTransformType["BACKUP_ZERO_ETL_ICEBERG_TRANSFORM_TYPE_MONTH"] = "MONTH";
    BackupZeroEtlIcebergTransformType["BACKUP_ZERO_ETL_ICEBERG_TRANSFORM_TYPE_DAY"] = "DAY";
    BackupZeroEtlIcebergTransformType["BACKUP_ZERO_ETL_ICEBERG_TRANSFORM_TYPE_HOUR"] = "HOUR";
})(BackupZeroEtlIcebergTransformType || (BackupZeroEtlIcebergTransformType = {}));
